import { makeStyles } from "$components/mui-styles";
import { TextField } from "@material-ui/core";
import React from "react";

interface StyleProps {
  minWidth?: string;
  width?: string;
}

type Props = StyleProps & React.ComponentProps<typeof TextField>;

const useStyles = makeStyles<StyleProps>((theme) => ({
  input: (props) => ({
    minWidth: props.minWidth,
    width: props.width,
  }),
  label: {
    color: `${theme.palette.text.secondary} !important`,
  },
}));

export const InfoField: FC<Props> = ({ minWidth, width, ...props }) => {
  const classes = useStyles({ minWidth, width });

  return (
    <TextField
      disabled
      className={classes.input}
      {...props}
      InputLabelProps={{
        className: classes.label,
        htmlFor: props.id,
        shrink: true,
        ...props.InputLabelProps,
      }}
    />
  );
};
